// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3SGTv","inputDescription":"styles_inputDescription__1y-mc"};